{
  "version": "v4.2.5",
  "name": "Swap",
  "bytecodeTemplate": "0101030004004056b41700{0}160047cc17011601c5194c0516000d0c{0}d465b302f90c0e{1}010717031702{2}{3}464c04{2}{3}13c3038d7ea4c68000a7{4}0c2f4c0f{2}1603{5}a3{2}{3}{4}{5}{6}{7}13060c{1}01104a4025{5}0c2f4c0f{2}1602{4}a3{2}{3}{4}{5}{6}{7}13060c{1}01104a12{2}7a1602{4}a31603{5}a3{2}{3}{4}{5}{6}{7}13060c{1}0110",
  "fieldsSig": {
    "names": [
      "dexAccount",
      "tokenPair",
      "sender",
      "to",
      "amount0In",
      "amount1In",
      "amount0Out",
      "amount1Out"
    ],
    "types": [
      "IDexAccount",
      "TokenPair",
      "Address",
      "Address",
      "U256",
      "U256",
      "U256",
      "U256"
    ],
    "isMutable": [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}